import BaseApi from '../base/apiBase.service';

export default class UserService extends BaseApi {
  constructor(args) {
    super(args);

    this.serviceEndpoints = {
      baseUrl: process.env.REACT_APP_BACKEND_URL,
      get: '/api/user/',
      create: '/api/user/',
      update: '/api/user/',
      exportAll: '/api/user/export',
    };
  }

  async getByParameters(data) {
    return super.getByParameters(data);
  }

  async update(data) {
    return super.update(data);
  }

  async create(data) {
    return super.create(data);
  }

  async get(payload) {
    return super.get(payload, this.serviceEndpoints.get);
  }

  async exportAll(data) {
    return super.get(data, this.serviceEndpoints.exportAll);
  }
}
